import React, { FC, useEffect, useState } from 'react';
import { Box } from '@mui/material';

export interface Image {
    src: string;
    alt: string;
}

interface ImageDisplayProps {
    frontImage: Image;
    sideImage: Image;
    onError?: () => void;
    onLoad?: () => void;
}

const BodyScanImagePair: FC<ImageDisplayProps> = ({
                                                      frontImage,
                                                      sideImage,
                                                      onError,
                                                      onLoad,
                                                  }) => {
    const isProfileImage = !!frontImage?.alt && frontImage?.alt.toLowerCase().includes('profile');
    // slide count is currently unaffected, consider fixing this is invalid src is a common issue
    const handleBodyImageError = () => {
        if (onError) {
            onError();
        }
    };

    const [isLeftLoaded, setIsLeftLoaded] = useState(false);
    const [isRightLoaded, setIsRightLoaded] = useState(false);

    useEffect(() => {
        if (onLoad && isLeftLoaded && isRightLoaded) {
            onLoad();
        }
    }, [isLeftLoaded, isRightLoaded, onLoad]);

    if (isProfileImage) {
        return (
            <Box
                data-testid="BodyScanImagePair"
                sx={{
                    width: '100%',
                    height: 'inherit',
                    backgroundColor: 'inherit',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: 2,
                    gap: 2,
                }}
            >
                <Box
                    sx={{
                        flex: '1 0 40%',
                        height: '100%',
                        boxSizing: 'border-box',
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <Box
                        component="img"
                        src={frontImage.src}
                        alt={frontImage.alt}
                        sx={{
                            maxHeight: '100%',
                            maxWidth: '100%',
                            objectFit: 'contain',
                        }}
                        onError={handleBodyImageError}
                        onLoad={() => setIsLeftLoaded(true)}
                    />
                </Box>
                <Box
                    sx={{
                        flex: '1 1 10%',
                        height: '100%',
                        boxSizing: 'border-box',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <Box
                        component="img"
                        src={sideImage.src}
                        alt={sideImage.alt}
                        sx={{
                            maxHeight: '100%',
                            maxWidth: '100%',
                            objectFit: 'contain',
                        }}
                        onError={handleBodyImageError}
                        onLoad={() => setIsRightLoaded(true)}
                    />
                </Box>
            </Box>
        );
    }
    return (
        <Box
            data-testid="BodyScanImagePair"
            sx={{
                width: '100%',
                height: 'inherit',
                backgroundColor: 'inherit',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
            }}
        >
            <Box
                sx={{
                    flex: 1,
                    height: '100%',
                    boxSizing: 'border-box',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    overflow: 'hidden',
                }}
            >
                <Box
                    component="img"
                    src={frontImage.src}
                    alt={frontImage.alt}
                    sx={{
                        maxHeight: '100%',
                        maxWidth: '100%',
                        objectFit: 'contain',
                    }}
                    onError={handleBodyImageError}
                    onLoad={() => setIsLeftLoaded(true)}
                />
            </Box>
            <Box
                sx={{
                    flex: 1,
                    height: '100%',
                    boxSizing: 'border-box',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    overflow: 'hidden',
                }}
            >
                <Box
                    component="img"
                    src={sideImage.src}
                    alt={sideImage.alt}
                    sx={{
                        maxHeight: '100%',
                        maxWidth: '100%',
                        objectFit: 'contain',
                    }}
                    onError={handleBodyImageError}
                    onLoad={() => setIsRightLoaded(true)}
                />
            </Box>
        </Box>
    );
};
export default BodyScanImagePair;

BodyScanImagePair.defaultProps = {
    onError: undefined,
    onLoad: undefined,
};
